import { NgModule } from '@angular/core';
import { AppsSharedModule, BaseAdministrationModule, BaseAssignmentsModule, BaseSharedModule } from 'base';
import { AddCandidateComponent } from './_components/add-candidate/add-candidate.component';
import { ConditionsFormComponent } from './_components/add-candidate/conditions-form/conditions-form.component';
import { MasterDataFormComponent } from './_components/add-candidate/master-data-form/master-data-form.component';
import { QualificationFormComponent } from './_components/add-candidate/qualification-form/qualification-form.component';
import { EmployeeModalOperationsComponent } from './_components/employee-operation-modal/_components/employee-modal-operations/employee-modal-operations.component';
import { EmployeeModalTimeRecordingsComponent } from './_components/employee-operation-modal/_components/employee-modal-time-recordings/employee-modal-time-recordings.component';
import { TimeRecordingsListItemComponent } from './_components/employee-operation-modal/_components/employee-modal-time-recordings/_components/time-recordings-list-item/time-recordings-list-item.component';
import { EmployeeShortInfoComponent } from './_components/employee-operation-modal/_components/employee-short-info/employee-short-info.component';
import { OfferPositionsModalComponent } from './_components/offer-positions-modal/offer-positions-modal.component';
import { CreateCustomerInfoModalComponent } from './_components/create-customer-info-modal/create-customer-info-modal.component';
import { EditCandidateComponent } from './_components/edit-candidate/edit-candidate.component';
import { MasterDataComponent } from './_components/edit-candidate/components/master-data/master-data.component';
import { AbsenceTimeComponent } from './_components/edit-candidate/components/absence-time/absence-time.component';
import { StazzleAppComponent } from './_components/edit-candidate/components/stazzle-app/stazzle-app.component';
import { AddAbsenceComponent } from './_components/add-absence/add-absence.component';
import { EditCandidateDocumentComponent } from './_components/edit-candidate/components/_components/edit-candidate-document/edit-candidate-document.component';
import { EmployeeOperationModalComponent } from './_components/employee-operation-modal/employee-operation-modal.component';
import { CandidateLogOffModalComponent } from './_components/edit-candidate/components/candidate-log-off-modal/candidate-log-off-modal.component';
import { DocumentsComponent } from './_components/edit-candidate/components/documents/documents.component';
import { CandidateLogOffSummaryModalComponent } from './_components/edit-candidate/components/candidate-log-off-summary-modal/candidate-log-off-summary-modal.component';
import { EditTimeRecordsModalComponent } from './_components/employee-operation-modal/_components/employee-modal-time-recordings/_components/edit-time-records-modal/edit-time-records-modal.component';
import { QualificationPriceGroupComponent } from './_components/qualification-price-group/qualification-price-group.component';
import { EmployeeDocumentsComponent } from './_components/employee-operation-modal/_components/employee-documents/employee-documents.component';
import { EmployeeDocumentComponent } from './_components/employee-operation-modal/_components/employee-document/employee-document.component';
import { OfferConfirmationModalComponent } from './_components/offer-confirmation-modal/offer-confirmation-modal.component';
import { AbsencesModalComponent } from './_components/absences-modal/absences-modal.component';
import { IndustrySurchargesComponent } from './_components/industry-surcharges/industry-surcharges.component';
import { IndustrySurchargesStaggeringsComponent } from './_components/industry-surcharges/industry-surcharges-staggerings/industry-surcharges-staggerings.component';
import { OfferConfirmationModalFooterComponent } from './_components/offer-confirmation-modal/offer-confirmation-modal-footer/offer-confirmation-modal-footer.component';
import { OfferSurchargesHandlerComponent } from './_components/surcharges/offer-surcharges-handler.component';
import { IndustrySurchargesFormComponent } from './_components/industry-surcharges/industry-surcharges-form/industry-surcharges-form.component';
import { GrowthCalculatedDateFieldComponent } from './_components/calculated-date-field/growth-calculated-date-field.component';

@NgModule({
  imports: [BaseSharedModule, AppsSharedModule, BaseAssignmentsModule, BaseAdministrationModule],
  declarations: [
    AddCandidateComponent,
    ConditionsFormComponent,
    MasterDataFormComponent,
    QualificationFormComponent,
    CreateCustomerInfoModalComponent,
    EditCandidateComponent,
    MasterDataComponent,
    AbsenceTimeComponent,
    StazzleAppComponent,
    AddAbsenceComponent,
    EditCandidateDocumentComponent,
    EmployeeModalOperationsComponent,
    EmployeeModalTimeRecordingsComponent,
    EmployeeShortInfoComponent,
    TimeRecordingsListItemComponent,
    EmployeeOperationModalComponent,
    CandidateLogOffModalComponent,
    DocumentsComponent,
    CandidateLogOffSummaryModalComponent,
    EditTimeRecordsModalComponent,
    QualificationPriceGroupComponent,
    EmployeeDocumentsComponent,
    EmployeeDocumentComponent,
    OfferConfirmationModalComponent,
    AbsencesModalComponent,
    OfferPositionsModalComponent,
    IndustrySurchargesComponent,
    IndustrySurchargesStaggeringsComponent,
    IndustrySurchargesFormComponent,
    OfferConfirmationModalFooterComponent,
    OfferSurchargesHandlerComponent,
    GrowthCalculatedDateFieldComponent,
  ],
  exports: [
    BaseSharedModule,
    AddCandidateComponent,
    ConditionsFormComponent,
    MasterDataFormComponent,
    QualificationFormComponent,
    CreateCustomerInfoModalComponent,
    EditCandidateComponent,
    EmployeeModalOperationsComponent,
    EmployeeModalTimeRecordingsComponent,
    EmployeeShortInfoComponent,
    TimeRecordingsListItemComponent,
    EmployeeOperationModalComponent,
    CandidateLogOffModalComponent,
    DocumentsComponent,
    CandidateLogOffSummaryModalComponent,
    EditTimeRecordsModalComponent,
    QualificationPriceGroupComponent,
    EmployeeDocumentsComponent,
    EmployeeDocumentComponent,
    OfferConfirmationModalComponent,
    AbsencesModalComponent,
    OfferPositionsModalComponent,
    IndustrySurchargesComponent,
    IndustrySurchargesStaggeringsComponent,
    IndustrySurchargesFormComponent,
    OfferSurchargesHandlerComponent,
    GrowthCalculatedDateFieldComponent,
  ],
})
export class SharedModule {}
